import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var ResponsiveVideo = function ResponsiveVideo(props) {
  var src = props.src,
    className = props.className,
    allowFullScreen = props.allowFullScreen,
    aspectRatio = props.aspectRatio;
  var wrapperClassName = classNames('video-responsive', "video-responsive-".concat(aspectRatio), className && className);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement("iframe", {
    src: src,
    allowFullScreen: allowFullScreen
  }));
};
ResponsiveVideo.ASPECT_RATIO_4_BY_3 = '4by3';
ResponsiveVideo.ASPECT_RATIO_16_BY_9 = '16by9';
ResponsiveVideo.defaultProps = {
  aspectRatio: ResponsiveVideo.ASPECT_RATIO_16_BY_9,
  allowFullScreen: true
};
ResponsiveVideo.propTypes = {
  src: PropTypes.string.isRequired,
  aspectRatio: PropTypes.oneOf([ResponsiveVideo.ASPECT_RATIO_4_BY_3, ResponsiveVideo.ASPECT_RATIO_16_BY_9]),
  allowFullScreen: PropTypes.bool
};
export default ResponsiveVideo;